import { __assign, __rest } from "tslib";
import TextField, { VARIANT } from '@mos-cat/text-field';
import Inputmask from 'inputmask';
import * as React from 'react';
import { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';
function MaskedField(props, ref) {
    var inputRef = useRef(null);
    useImperativeHandle(ref, function () { return inputRef.current; });
    var maskOptions = props.maskOptions, restProps = __rest(props, ["maskOptions"]);
    var comparableMaskOptions = JSON.stringify(maskOptions);
    useEffect(function () {
        if (!inputRef.current)
            return;
        if (!maskOptions)
            return;
        var input = inputRef.current;
        Inputmask(maskOptions).mask(input);
        return function () {
            if (!input || !input.inputmask)
                return;
            input.inputmask.remove();
        };
        // Отключаем потому что оно ругается на отсутствие maskOptions, но на самом деле мы передаём опции, но в сериализованном виде
        // При модификациях эффекта необходимо включить проверку для подсветки в IDE
        // и отключить перед коммитом, чтобы автофиксер не сломал всё нафиг
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [comparableMaskOptions]);
    useEffect(function () {
        if (props.value === '')
            inputRef.current.placeholder = '';
    }, [props.value]);
    return React.createElement(TextField, __assign({}, restProps, { ref: inputRef }));
}
export default Object.assign(forwardRef(MaskedField), { VARIANT: VARIANT });
export { VARIANT };
//# sourceMappingURL=MaskedField.js.map